import { render, staticRenderFns } from "./PriceDistribution.vue?vue&type=template&id=358ba794&scoped=true&"
import script from "./PriceDistribution.vue?vue&type=script&lang=js&"
export * from "./PriceDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ba794",
  null
  
)

export default component.exports